<template>
  <div class="rumie-input">
    <span>
      <i :class="icon" class="input__search"></i>
    </span>
    <input
      ref="input"
      class="rumie-input__field"
      :class="inputClass"
      v-bind="$attrs"
      :value="value"
      @input="(e) => $emit('input', e.target.value)"
      @blur="$emit('blur')"
      :maxlength="maxlength"
    />
    <span>
      <i v-show="!!clearable" :class="clearableClass" @click="$emit('input', '')" class="fa"></i>
      <span v-show="maxlengthProvided" :class="maxlengthClass">{{this.value && this.value.length || 0}}/{{this.maxlength}}</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "RumieInput",
  props: {
    value: [String, Number],
    icon: String,
    clearable: Boolean,
    maxlength: {
      type: Number,
      default: 524288
    }
  },
  computed: {
    maxlengthProvided() {
      return this.maxlength !== 524288;
    },
    inputClass() {
      return {
        "rumie-input__field--icon": this.icon
      };
    },
    maxlengthClass() {
      return {
        "max-length": !!this.maxlength
      }
    },
    clearableClass() {
      return {
        "fa-times": !!this.value
      };
    }
  }
};
</script>

<style scoped>
.input__search {
  margin-left: var(--spacing-4);
  position: absolute;
  margin-top: 15px;
  color: var(--grey-dark);
  font-size: var(--base);
}

.max-length {
  position: absolute;
  margin-left: -45px;
  margin-top: 17px;
  color: var(--grey-dark);
  font-size: var(--xs);
  cursor: pointer;
}

.fa-times {
  position: absolute;
  margin-left: -30px;
  margin-top: 15px;
  color: var(--grey-dark);
  font-size: var(--base);
  cursor: pointer;
}

.rumie-input__field {
  border: none;
  box-sizing: border-box;
  background: var(--grey-lighter);
  border-radius: var(--border-radius-md);
  padding: var(--spacing-3) var(--spacing-4);
  width: 100%;
  line-height: var(--leading-normal);
}

.rumie-input__field--icon {
  padding-left: var(--spacing-10);
}

.rumie-input__field:disabled {
  opacity: var(--opacity-50);
}
</style>
